import { clsx } from 'clsx';
import { jsx } from 'react/jsx-runtime';

const Section = ({
  as: Element = 'div',
  children,
  className,
  withHorizontalPadding = false,
  role = undefined,
  ...restProps
}) => {
  return /*#__PURE__*/jsx(Element, {
    className: clsx('np-section', className, {
      'np-section--with-horizontal-padding': withHorizontalPadding
    }),
    role: role,
    ...restProps,
    children: children
  });
};

export { Section as default };
//# sourceMappingURL=Section.mjs.map
